import { useNavigate, useParams } from "react-router-dom";

import userService from "@services/user.service";

import { PopupActions } from "@store/popupStore";

const VerifyEmail = () => {
  const parameters = useParams();
  const navigate = useNavigate();
  const { token } = parameters;

  if (!token) {
    PopupActions.openAlert({
      duration: 4000,
      message: "Invalid token",
      severity: "error",
    });
    navigate("/login");
  }
  userService
    .verifyEmail(token)
    .then(() => {
      PopupActions.openAlert({
        duration: 4000,
        message: "Email verified successfully.",
        severity: "success",
      });
      navigate("/login");
    })
    .catch(() => {
      PopupActions.openAlert({
        duration: 4000,
        message: "Failed to verify email",
        severity: "error",
      });
      navigate("login");
    });

  return null;
};

export default VerifyEmail;
